import { confirmable, ConfirmDialog, createConfirmation } from "react-confirm";
import { RxCross2 } from "react-icons/rx";

export interface INotificationProps {
  confirm?: string;
  cancel?: string;
  title?: string;
  message?: string;
}

const Notification: ConfirmDialog<INotificationProps, boolean> = (props) => {
  return (
    <div className="h-screen w-screen fixed top-0 left-0 bg-gray-900/70 backdrop-blur-sm place-content-center show scroll-hidden">
      <div className="w-100 sm:w-2/3 xl:w-3/5 2xl:w-2/5 mx-auto">
        <div className="w-2/5 mx-auto bg-white items-center rounded-xl shadow-md-0 overflow-hidden">
          <div className="flex p-4 bg-gray-200 items-center">
            <div className="w-1/2">
              <div className="flex items-center space-x-1">
                <span>{props.title}</span>
              </div>
            </div>
            <div className="w-1/2">
              <div className="flex items-center space-x-1 justify-end cursor-pointer">
                <RxCross2 onClick={() => props.proceed(false)} />
              </div>
            </div>
          </div>
          <div className="p-4">
            <p className="text-sm">{props.message}</p>
          </div>
          <hr />
          <div className="grid grid-flow-col justify-stretch space-x-3 p-4">
            <button
              type="button"
              className="rounded-lg text-gray-400 text-sm tracking-wider font-medium outline-none bg-gray-100 hover:bg-gray-200 py-2"
              onClick={() => props.proceed(false)}
            >
              {props.cancel ?? "Cancel"}
            </button>
            <button
              type="button"
              className={`rounded-lg text-gray-800 text-sm tracking-wider font-medium outline-none bg-text-link`}
              onClick={() => props.proceed(true)}
            >
              {props.confirm ?? "Confirm"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export const notifcation = createConfirmation(confirmable(Notification));

export interface INotification {
  title: string;
  message: string;
  confirmations: IConfirmation[];
  success: string;
  reference: React.MutableRefObject<any>;
  reload?: boolean;
}

export interface IConfirmation {
  title: string;
  classes?: string;
  action: () => Promise<any>;
}
